// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"658484c1","330":"a652fafb","453":"6173f71a","556":"0fb724e7","710":"af0424b2","712":"468d7d62","828":"549b540d","855":"07c789b0"}[chunkId] + ".chunk.js";
};